import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { LocationEntity } from './location-entity.model';

@Injectable()
export class LocationsService {
    constructor(private http: HttpClient) {
    }

    getLocations(userId: number): Observable<any> {
        return this.http
            .get<{ locations: Array<String> }>(`servlets/appointments/locations/?userid=${userId}`, {observe: 'body'})
            .pipe(
                map((response: any) => response.locations)
            );
    }

    getLocationEntities(userId: number, mergeWithAppointmentLocations: boolean): Observable<Array<LocationEntity>> {
       return this.http
          .get<{ locations: Array<LocationEntity> }>(`servlets/locations/?mergeWithAppointmentLocations=${mergeWithAppointmentLocations}&userid=${userId}`, {observe: 'body'})
          .pipe(
             map((response: any) => response.locationEntities)
          );
    }
}
